var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.noLink)?_c('router-link',{attrs:{"to":_vm.to}},[_c('img',_vm._b({attrs:{"src":require("@/assets/img/Maintenance.png")}},'img',_vm.imgAttrs,false))]):_c('img',_vm._b({attrs:{"src":require("@/assets/img/Maintenance.png")}},'img',_vm.imgAttrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }